import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import Heading from 'app/components/shared/Heading';
import { ugcSummaryShape } from 'app/shapes/bibPage';
import Tabs from 'app/components/shared/Tabs';
import { QuotationsContainer } from '../Quotations';
import { SummariesContainer } from '../Summaries';
import { VideosContainer } from '../Videos';
import { AgeSuitabilityContainer } from '../AgeSuitability';
import { ContentNoticesContainer } from '../ContentNotices';

const UGC_TABS = {
  QUOTATIONS: 'quotations',
  SUMMARIES: 'summaries',
  VIDEOS: 'videos',
  SUITABILITY: 'suitability'
};

export class UGCTabs extends React.PureComponent {
  constructLabel(name) {
    const { summary } = this.props;
    const contentAdvisoriesCount = summary?.getIn(['contentAdvisories', 'total']) ?? 0;
    const ageSuitabilitiesCount = summary?.getIn(['ageSuitabilities', 'average']) ?? 0;

    let label = this.props.intl.formatMessage({ id: name });
    let count = summary?.getIn([name, 'total']) ?? 0;
    if (name === UGC_TABS.SUITABILITY) {
      if (contentAdvisoriesCount) {
        count = contentAdvisoriesCount;
      }
      if (ageSuitabilitiesCount) {
        count = ageSuitabilitiesCount;
      }
      if (count) {
        label += ageSuitabilitiesCount ? ` (${count}+)` : ` (${count})`;
      }
    } else if (count) {
      label += ` (${count})`;
    }

    return label;
  }

  render() {
    const { intl } = this.props;

    return (
      <div className="cp-ugc-tabs">
        <Heading tagName="h3" size="medium" variant>
          <FormattedMessage id="community_contributions" />
        </Heading>
        <Tabs
          ariaLabel={intl.formatMessage({ id: 'community_contributions' })}
          options={[
            {
              id: UGC_TABS.QUOTATIONS,
              label: this.constructLabel(UGC_TABS.QUOTATIONS),
              renderPanelBody: () => <QuotationsContainer />
            },
            {
              id: UGC_TABS.SUMMARIES,
              label: this.constructLabel(UGC_TABS.SUMMARIES),
              renderPanelBody: () => <SummariesContainer />
            },
            {
              id: UGC_TABS.VIDEOS,
              label: this.constructLabel(UGC_TABS.VIDEOS),
              renderPanelBody: () => <VideosContainer />
            },
            {
              id: UGC_TABS.SUITABILITY,
              label: this.constructLabel(UGC_TABS.SUITABILITY),
              renderPanelBody: () => (
                <>
                  <AgeSuitabilityContainer />
                  <ContentNoticesContainer />
                </>
              )
            }
          ]}
        />
      </div>
    );
  }
}

UGCTabs.propTypes = {
  summary: ugcSummaryShape
};

export default injectIntl(UGCTabs);
